import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
} from '@angular/forms';
import { UiModalComponent } from '@components';
import {
    IRoleSource,
    IUser,
    IUserRole,
} from '@models';
import { TranslateService } from '@ngx-translate/core';
import { UserGroupField } from '@pages/users/modals/user-group-import';

import { Subject } from 'rxjs';

const SCROLL_BUFFER = 300;

@Component({
    templateUrl: './check-permissions.modal.html',
    styleUrls: [
        './check-permissions.modal.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckPermissionsModalComponent
    extends UiModalComponent<IUser>
    implements OnInit {

    public form!: FormGroup;
    public username?: string;
    public tenantRoles?: IUserRole[];
    public scrollBottom = new Subject<boolean>();

    private _translate = this._injector.get<TranslateService>(TranslateService);

    ngOnInit() {
        this.form = this._injector.get(FormBuilder).group({
            [UserGroupField.UserName]: [[]],
            [UserGroupField.Domain]: [[]],
        });

        this.username = this.context.data && this.context.data.userName;
    }

    public onScroll(event: Event) {
        const elem = <HTMLElement>event.target!;
        if ((elem.offsetHeight + elem.scrollTop + SCROLL_BUFFER) >= elem.scrollHeight) {
            this.scrollBottom.next();
        }
    }

    public formatRoleSources = (sources: IRoleSource[]) =>
        sources.map(
            source => source.isInherited
                ? source.username
                : this._translate.instant('check_perms_modal_explicit'),
        ).join(', ')

}
